'use strict';

var jQuery = require('jquery');
var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');

var Classnames = require('classnames');

var Global = require('../global');
var Components = require('../components');
var Constants = require('../constants');
var ResponsiveMixin = require('../global').ResponsiveMixin;

var DeviceImage = Global.DeviceImage;
var Media = Components.Media;

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./linktile.scss');
}

/*
 * Abstract base class - a link containing:
 *     - an image
 *     - a label (a category name or a product ID)
 *     - a hover effect
 *
 * See usage in thumb-grids.jsx
 */
var LinkTile = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        // Unique ID (generally `id` col from db) for <a> tag (used to separate GA results for identical link targets)
        id:     React.PropTypes.string,

        // URL to link to
        target:    React.PropTypes.string,

        // img DOM
        image:  React.PropTypes.node,

        // If true, use <Link> rather than <a> (false for Homepage which links from module Pages.jsx to Collections.jsx)
        singlePageLink: React.PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            alt: null
        };
    },
    _onClick: function() {
        // Store the scroll position in a dynamic list when a LinkTile is clicked #228
        var scrollTop = jQuery(window).scrollTop();
        history.replaceState({
            scrollTop: scrollTop,
        }, window.location.pathname);
    },
    render: function() {
        var el;
        var props = {
            className: 'linktile ' + this.props.className,
            key:       this.props.id,
            id:        this.props.id,
            onClick:   this._onClick,
        };
        if (this.props.singlePageLink) {
            el = ReactRouter.Link;
            props.to = this.props.target;
        } else {
            el = 'a';
            props.href = this.props.target;
        }
        return (  // TODO move to <Link> as we consolidate into single page app
            React.createElement(el, props, (
                <div>
                    {this.props.image}
                    {this.props.children &&
                        <div className='linktile-title-bg' />
                    }
                    <div className='linktile-title'>
                        {this.state.viewportLayout == 'desktop' ?
                            <div className='linktile-title-arrow'>
                                <DeviceImage src='global/linktile/rollover.png' alt="tile arrow" width='77' height='22'/>
                            </div>
                        : null}
                        <p>
                            {this.props.children}
                        </p>
                    </div>
                </div>
            ))
        );
    },
});

/*
 * LinkTile that uses default/landscape image from /categories (or for DYO from /images/designtool/space-thumbs/)
 *     - Category name is below photo on a black background
 * Usages:
 *     - Homepage
 *     - Collection top level categories
 *     - Collection subcategories (Office Chairs)
 *     - DYO tab 1
 */
var CollectionLinkTile = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        // URL to link to
        target:    React.PropTypes.string,

        // catCat urlkey used for filename on disk
        urlkey:  React.PropTypes.string,

        // image alt text
        alt: React.PropTypes.string,

        // If true, use <Link> rather than <a> (false for Homepage which links from module Pages.jsx to Collections.jsx)
        singlePageLink: React.PropTypes.bool,

        // Used to determine path of image file in static images
        source: React.PropTypes.oneOf([ 'homepage', 'collection', 'designtool' ]),
    },
    getDefaultProps: function() {
        return {
            singlePageLink: false,
            source: 'collection',
        }
    },
    render: function() {
        var id = 'LinkTile-' + this.props.urlkey
        if (this.state.viewportLayout == 'desktop') {
            var path = `thumbs/desktop/${this.props.source}/${this.props.urlkey}.jpg`
        } else {
            var path = `thumbs/mobile/${this.state.viewportLayout}/${this.props.urlkey}.jpg`
        }
        var staticSrc = `${Payload.static}/images/categories/${path}`
        var webpSrc = `${Payload.webp}/images/categories/${path}`
        var img =  <picture>
                        <source srcSet={`${webpSrc}.webp`} type="image/webp"  width='378' height='237'/>
                        <source srcSet={staticSrc} type="image/jpg"  width='378' height='237'/>
                        <img key={staticSrc} src={staticSrc} className='linktile-image'  alt={this.props.alt} width='378' height='237'/>
                   </picture>
        return (
            <LinkTile key            = {id}
                      id             = {id}
                      target         = {this.props.target}
                      image          = {img}
                      singlePageLink = {this.props.singlePageLink}
                      className      = 'linktile-collection'>
                {this.props.children}
            </LinkTile>
        );
    },
});

var CollectionPageLinkTile = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        // URL to link to
        target:    React.PropTypes.string,

        // catCat urlkey used for filename on disk
        urlkey:  React.PropTypes.string,

        // image alt text
        alt: React.PropTypes.string,

        // If true, use <Link> rather than <a> (false for Homepage which links from module Pages.jsx to Collections.jsx)
        singlePageLink: React.PropTypes.bool,

        // Used to determine path of image file in static images
        source: React.PropTypes.oneOf([ 'homepage', 'collection', 'designtool' ]),
    },
    getDefaultProps: function() {
        return {
            singlePageLink: false,
            source: 'collection',
        }
    },
    render: function() {
        var id = 'LinkTile-' + this.props.urlkey;
        if (this.state.viewportLayout == 'desktop') {
            if (this.props.order_idx >= 1 && this.props.order_idx <= 6){
                // Large images for tier 1 images
                var src = `//media.strongproject.com/homepage/${this.props.img_src}.${this.state.viewportLayout}.big.jpg`;
                var size = {width:'378', height:'236'}
            } else if (this.props.order_idx >= 6) {
                // Small images for tier 2 images
                var src = `//media.strongproject.com/homepage/${this.props.img_src}.${this.state.viewportLayout}.small.jpg`;
                var size = {width:'282', height:'176'}
            }
        } else {
            var src = `//media.strongproject.com/homepage/${this.props.img_src}.mobile.${this.state.viewportLayout}.jpg`;
        }
        var img = <picture>
                    <source srcSet={`${src}.webp`} type="image/webp" width={!!size && size.width} height={!!size && size.height}/>
                    <source srcSet={src} type="image/jpg" width={!!size && size.width} height={!!size && size.height}/>
                    <img key={src} src={src} className='linktile-image' width={!!size && size.width} height={!!size && size.height} alt={this.props.alt} />
                  </picture>
        return (
            <LinkTile key            = {id}
                      id             = {id}
                      target         = {this.props.target}
                      image          = {img}
                      singlePageLink = {this.props.singlePageLink}
                      className      = 'linktile-collection'>
                {this.props.children}
            </LinkTile>
        );
    },
});

const version = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const version = urlParams.get('version')
        if (version === "1")
            return ""
        return version || ""
    } catch (e) {
        return "" 
    }
}

var HomepageLinkTile = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        // URL to link to
        target:    React.PropTypes.string,

        // catCat urlkey used for filename on disk
        urlkey:  React.PropTypes.string,

        // image alt text
        alt: React.PropTypes.string,

        // If true, use <Link> rather than <a> (false for Homepage which links from module Pages.jsx to Collections.jsx)
        singlePageLink: React.PropTypes.bool,

        // Used to determine path of image file in static images
        source: React.PropTypes.oneOf([ 'homepage', 'collection', 'designtool' ]),
    },
    getDefaultProps: function() {
        return {
            singlePageLink: false,
            source: 'collection',
        }
    },
    render: function() {
        var id = 'LinkTile-' + this.props.urlkey;
        if (this.state.viewportLayout == 'desktop') {
            if (this.props.order_idx >= 1 && this.props.order_idx <= 1){
                var src = `//media.strongproject.com/homepage/${this.props.img_src}.desktop.hero${version()}.jpg`;
                var size = {width:'1150', height:'400'}
            } else if (this.props.order_idx >= 2 && this.props.order_idx <= 3){
                // Large images for tier 1 images
                var src = `//media.strongproject.com/homepage/${this.props.img_src}.desktop.big.jpg`;
                var size = {width:'571', height:'357'}
            } else if (this.props.order_idx >= 4 && this.props.order_idx <= 6) {
                // Medium sized images for tier 2 images
                var src = `//media.strongproject.com/homepage/${this.props.img_src}.desktop.big.jpg`;
                var size = {width:'378', height:'237'}
            } else if (this.props.order_idx >= 7 && this.props.order_idx <= 14) {
                // Small images for tier 3 images
                var src = `//media.strongproject.com/homepage/${this.props.img_src}.desktop.small.jpg`;
                var size = {width:'282', height:'176'}
            }
        } else {
            var src = `//media.strongproject.com/homepage/${this.props.img_src}.mobile.${this.state.viewportLayout}.jpg`;
            var size = {width:'418', height:'261'}
        }
        var img =  <picture>
                        <source srcSet={`${src}.webp`} type="image/webp" width={!!size && size.width} height={!!size && size.height}/>
                        <source srcSet={src} type="image/jpg" width={!!size && size.width} height={!!size && size.height}/>  
                        <img key={src} src={src} className='linktile-image' width={!!size && size.width} height={!!size && size.height} alt={this.props.alt} />
                   </picture>
        return (
            <LinkTile key            = {id}
                      id             = {id}
                      target         = {this.props.target}
                      image          = {img}
                      singlePageLink = {this.props.singlePageLink}
                      className      = 'linktile-collection'>
                {this.props.children}
            </LinkTile>
        );
    },
});

/*
 * LinkTile that uses catalog media
 *     - Product ID is are overlaid on photo
 * Usage:
 *     - Collection dynamic listing
 *     - DYO tab 2
 */
var MediaLinkTile = React.createClass({
    propTypes: {
        object: React.PropTypes.shape({
            // URL to link to
            url: React.PropTypes.string,

            // URL of media
            image: React.PropTypes.string,

            // see distribute.js
            resize: React.PropTypes.shape({
                width: React.PropTypes.number.isRequired,
                height: React.PropTypes.number.isRequired,
            }).isRequired,
        }).isRequired,
    },
    render: function() {
        var o = this.props.object;
        var id = 'LinkTile-' + o.filename;
        var style = {
            width: o.resize.width,
            height: o.resize.height,
        };
        var img = <Media key={o.image} media={o} width={o.resize.width} style={style} />
        return (
            <LinkTile key            = {id}
                      id             = {id}
                      target         = {o.url}
                      image          = {img}
                      singlePageLink = {true}
                      className      = 'linktile-media'>
                {this.props.children}
            </LinkTile>
        );
    },
});

module.exports = {
    CollectionLinkTile: CollectionLinkTile,
    MediaLinkTile:      MediaLinkTile,
    HomepageLinkTile:   HomepageLinkTile,
    CollectionPageLinkTile: CollectionPageLinkTile,
};




// WEBPACK FOOTER //
// ./src/collections/linktile.jsx